const $ = (selector, root = document) => root.querySelector(selector);
const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

function formatMoney(cents) {
  return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: 'USD'
  }).format((Number(cents) || 0) / 100);
}

async function getCart() {
  const response = await fetch(`${window.EquipTheme.cartUrl}.js`, { headers: { Accept: 'application/json' } });
  if (!response.ok) throw new Error('Unable to load cart');
  return response.json();
}

function renderCart(cart) {
  const body = $('[data-cart-drawer-body]');
  const countNodes = $$('[data-cart-count]');
  countNodes.forEach((node) => { node.textContent = cart.item_count; node.hidden = cart.item_count < 1; });
  if (!body) return;
  if (!cart.items.length) {
    body.innerHTML = '<div class="drawer-empty"><h3>Your cart is empty</h3><a class="button" href="/products/prime-protein">Shop Prime Protein</a></div>';
  } else {
    body.innerHTML = cart.items.map((item) => `
      <div class="drawer-line">
        <img src="${item.image || ''}" alt="${item.product_title.replace(/"/g, '&quot;')}">
        <div><strong>${item.product_title}</strong><div class="muted">${item.variant_title || ''}</div>
        <div>${item.quantity} x ${formatMoney(item.final_price)}</div></div>
      </div>`).join('');
  }
  const subtotal = $('[data-cart-subtotal]');
  if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
}

function openDrawer() {
  document.body.classList.add('drawer-open');
  const drawer = $('#CartDrawer');
  if (drawer) drawer.setAttribute('aria-hidden', 'false');
}

function closeDrawer() {
  document.body.classList.remove('drawer-open');
  const drawer = $('#CartDrawer');
  if (drawer) drawer.setAttribute('aria-hidden', 'true');
}

async function refreshCart(open = false) {
  const cart = await getCart();
  renderCart(cart);
  if (open) openDrawer();
}

document.addEventListener('click', async (event) => {
  const opener = event.target.closest('[data-cart-open]');
  if (opener) { event.preventDefault(); await refreshCart(true); return; }
  if (event.target.closest('[data-cart-close]')) { event.preventDefault(); closeDrawer(); return; }
  const menu = event.target.closest('[data-menu-toggle]');
  if (menu) { event.preventDefault(); const nav = $('#MobileNav'); if (nav) nav.classList.toggle('open'); return; }
  const thumb = event.target.closest('[data-product-thumb]');
  if (thumb) {
    $$('.product-thumb').forEach((node) => node.classList.remove('active'));
    thumb.classList.add('active');
    const main = $('[data-product-main-image]');
    if (main) { main.src = thumb.dataset.image; main.srcset = ''; }
    return;
  }
  const variant = event.target.closest('[data-variant-id]');
  if (variant) {
    const root = variant.closest('[data-product-root]') || document;
    $$('[data-variant-id]', root).forEach((node) => node.classList.remove('active'));
    variant.classList.add('active');
    $$('input[name="id"]', document).forEach((input) => { input.value = variant.dataset.variantId; });
    $$('[data-sticky-variant]', document).forEach((select) => { select.value = variant.dataset.variantId; });
    const label = $('[data-selected-variant]', root); if (label) label.textContent = variant.dataset.variantTitle;
    return;
  }
  const bundle = event.target.closest('[data-bundle-qty]');
  if (bundle) {
    const root = bundle.closest('[data-product-root]') || document;
    $$('[data-bundle-qty]', root).forEach((node) => node.classList.remove('active'));
    bundle.classList.add('active');
    const radio = $('input[type="radio"]', bundle); if (radio) radio.checked = true;
    $$('input[name="quantity"]', document).forEach((input) => { input.value = bundle.dataset.bundleQty; });
  }
});

document.addEventListener('change', (event) => {
  if (event.target.matches('[data-sticky-variant]')) {
    const button = $(`[data-variant-id="${event.target.value}"]`); if (button) button.click();
  }
});

document.addEventListener('submit', async (event) => {
  const form = event.target.closest('.js-product-form');
  if (!form) return;
  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  if (button) button.disabled = true;
  try {
    const response = await fetch(`${window.EquipTheme.cartAddUrl}.js`, {
      method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form)
    });
    if (!response.ok) throw new Error('Unable to add item');
    await refreshCart(true);
  } catch (error) {
    window.alert(error.message);
  } finally {
    if (button) button.disabled = false;
  }
});

document.addEventListener('DOMContentLoaded', () => refreshCart(false).catch(() => {}));
